<template lang="pug">
.contact
  bw-wavey-bottom
  bw-contact
</template>

<script>
import BwWaveyBottom from "@/components/shared/BwWaveyBottom";
import BwContact from "@/components/chunks/BwContact";
export default {
  components: {
    BwWaveyBottom,
    BwContact
  }
};
</script>

<style lang="stylus" scoped>
.contact
    padding-top: 250px
</style>
